import { render, staticRenderFns } from "./payFeeOrderList.vue?vue&type=template&id=245e0944&scoped=true"
import script from "./payFeeOrderList.vue?vue&type=script&lang=js"
export * from "./payFeeOrderList.vue?vue&type=script&lang=js"
import style0 from "./payFeeOrderList.vue?vue&type=style&index=0&id=245e0944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e0944",
  null
  
)

export default component.exports